export default "__VITE_ASSET__0iFNvtTv__"